import React, { useState, useEffect, useContext } from 'react';
import { DcContext } from './context'; 

const Intro = (props) => {
  // * state
  const [userSettings, setUserSettings] = useState({}); 

  // * context 
  const appContext = useContext(DcContext);

  // * component mount/update
  useEffect(
    () => {
      const formState = appContext.getFormState(); 
      setUserSettings(formState.userSettings); 
    },
    [props]
  ); 

  // * render 
  let out = []; 
  if (userSettings.Intro) {
    out.push(
      <h2 key={'intro-heading'} className='intro-heading'>{userSettings.Intro}</h2>
    ); 
  }
  if (userSettings.Instructions) {
    out.push(
      <p key={'intro-copy'} className='intro-copy'>{userSettings.Instructions}</p>
    );
  }
  if (userSettings.DisclaimerDocUrl && userSettings.DisclaimerDocUrl.startsWith('http')) {
    out.push(
      <p key={'intro-disc-doclink'} className='intro-note intro-doclink'><a href={userSettings.DisclaimerDocUrl} target='_blank'>Offer Disclaimers Document</a></p>
    );
  }
  if (userSettings.ClaimsDocUrl && userSettings.ClaimsDocUrl.startsWith('http')) {
    out.push(
      <p key={'intro-doclink'} className='intro-note intro-doclink'><a href={userSettings.ClaimsDocUrl} target='_blank'>Claims Document</a></p>
    ); 
  }
  if (userSettings.LastUpdated) {
    out.push(
      <p key={'intro-updated'} className='intro-note'>Last Updated: {userSettings.LastUpdated}</p>
    );
  }
  if (userSettings.ContactEmail && userSettings.ContactEmail.indexOf('@') >= 0) {
    out.push(
      <p key={'intro-contact'} className='intro-note intro-doclink'><a href={"mailto:" + userSettings.ContactEmail + "?subject=Residential%20Disclaimer%20Tool"} target='_blank'>Contact Us</a></p>
    );
  }

  return ( 
    <div className='intro'>
      {out}
    </div>
  );
}; 

export default Intro;
